import { API } from "../index"

export const ERROR_CAPTURE_API_ENDPOINTS = {
  sync(data={}){
    return API.axios.voip_error_capture.v1.request({
      url: 'error-capture/sync',
      method: 'POST',
      data,
    })
  },
}